import {
  Modal,
  ModalContent,
  ModalHeader,
} from '@fountain/fountain-ui-components';
import React, { VFC } from 'react';

export interface ScoreApplicantModalProps {
  applicantId: string;
  scorecardTemplateId: string;
  scorecardName: string;
  handleClose: () => void;
}

// The scorecard form arrives with a follow-up ticket; this shell owns the
// open/close plumbing and the context the form needs.
export const ScoreApplicantModal: VFC<ScoreApplicantModalProps> = ({
  applicantId,
  scorecardTemplateId,
  scorecardName,
  handleClose,
}) => (
  <Modal
    data-testid="score-applicant-modal"
    ariaLabelledBy="score-applicant-modal-header"
    open
    onClose={handleClose}
    fullScreenOnMobile
    maxWidth={860}
  >
    <ModalHeader
      onClose={handleClose}
      ariaLabelledBy="score-applicant-modal-header"
      showIcon={false}
    >
      {scorecardName}
    </ModalHeader>
    <ModalContent
      data-applicant-id={applicantId}
      data-scorecard-template-id={scorecardTemplateId}
    />
  </Modal>
);
